import { render, staticRenderFns } from "./OrgDetails.vue?vue&type=template&id=261ed8c7&scoped=true&"
import script from "./OrgDetails.vue?vue&type=script&lang=js&"
export * from "./OrgDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrgDetails.vue?vue&type=style&index=0&id=261ed8c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261ed8c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VRow,VTextField})
